import type { TColor } from '@revert/color'
import { createContext } from 'react'
import { COLOR_WHITE, COLOR_BLACK } from '../../colors'

export type TCheckmarkThemeContext = {
  backgroundColor: TColor,
  activeBackgroundColor: TColor,
  hoveredBackgroundColor: TColor,
  activeHoveredBackgroundColor: TColor,
  pressedBackgroundColor: TColor,
  activePressedBackgroundColor: TColor,
  disabledBackgroundColor: TColor,
  activeDisabledBackgroundColor: TColor,
  borderColor: TColor,
  activeBorderColor: TColor,
  hoveredBorderColor: TColor,
  activeHoveredBorderColor: TColor,
  pressedBorderColor: TColor,
  activePressedBorderColor: TColor,
  disabledBorderColor: TColor,
  activeDisabledBorderColor: TColor,
  focusedOuterBorderColor: TColor,
  activeFocusedOuterBorderColor: TColor,
  iconColor: TColor,
  hoveredIconColor: TColor,
  pressedIconColor: TColor,
  disabledIconColor: TColor,
}

export const CheckmarkThemeContext = createContext<TCheckmarkThemeContext>({
  backgroundColor: COLOR_WHITE,
  activeBackgroundColor: COLOR_WHITE,
  hoveredBackgroundColor: COLOR_WHITE,
  activeHoveredBackgroundColor: COLOR_WHITE,
  pressedBackgroundColor: COLOR_WHITE,
  activePressedBackgroundColor: COLOR_WHITE,
  disabledBackgroundColor: COLOR_WHITE,
  activeDisabledBackgroundColor: COLOR_WHITE,
  borderColor: COLOR_WHITE,
  hoveredBorderColor: COLOR_WHITE,
  activeBorderColor: COLOR_WHITE,
  activeHoveredBorderColor: COLOR_WHITE,
  pressedBorderColor: COLOR_WHITE,
  activePressedBorderColor: COLOR_WHITE,
  disabledBorderColor: COLOR_WHITE,
  activeDisabledBorderColor: COLOR_WHITE,
  activeFocusedOuterBorderColor: COLOR_WHITE,
  focusedOuterBorderColor: COLOR_WHITE,
  iconColor: COLOR_BLACK,
  hoveredIconColor: COLOR_BLACK,
  pressedIconColor: COLOR_BLACK,
  disabledIconColor: COLOR_BLACK,
})
